module.exports = __webpack_public_path__ + "static/media/Woman_on_bike_4_credit_Sharon_Tshipa.3c8dface.jpg";